"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedLimitedPartnerCommitmentDataSchema = exports.LimitedPartnerPortfolioSummarySchema = exports.PortfolioOverviewGraphDataSchema = exports.LimitedPartnerCapitalTrendDataSchema = exports.LimitedPartnerCommitmentDetailSchema = exports.LimitedPartnerCommitmentSchema = exports.LimitedPartnerTapeOptionalStaticProps = exports.LimitedPartnerTapeRequiredStaticPropsIterable = exports.requiredGeneratedLoanTapeBaseFields = exports.LimitedPartnerNotFoundError = exports.LimitedPartnerFacilityType = void 0;
const v4_1 = require("zod/v4");
const UtilTypes = __importStar(require("./Utils"));
exports.LimitedPartnerFacilityType = 'capitalCallLine';
exports.LimitedPartnerNotFoundError = 'LimitedPartnersNotFoundError';
// For fund finance pipeline we will require that the following fields are present in the
// generated loan tape. some are required from the raw tape, and some are appended by
// createLimitedPartnersTape task.
// Besides these some dynamic properties will be added to the tape
// based on the node configuration.
exports.requiredGeneratedLoanTapeBaseFields = [
    //
    // required fields from the raw tape
    //
    {
        fieldName: 'committed_capital',
        fieldType: 'float',
    },
    {
        fieldName: 'called_capital',
        fieldType: 'float',
    },
    {
        fieldName: 'uncalled_capital',
        fieldType: 'float',
    },
    {
        fieldName: 'recallable_capital',
        fieldType: 'float',
    },
    // normalized required field appended by createLimitedPartnersTape task
    {
        fieldName: 'limited_partner_alias',
        fieldType: 'string',
    },
    //
    // props appended by createLimitedPartnersTape task from limited_partners table
    // for the matching limited partner.
    //
    {
        fieldName: 'limited_partner_id',
        fieldType: 'optionalString',
    },
    {
        fieldName: 'limited_partner_name',
        fieldType: 'optionalString',
    },
];
// required properties regarding LP from a receivable (commitment) tape.
exports.LimitedPartnerTapeRequiredStaticPropsIterable = [
    'committed_capital',
    'called_capital',
    'uncalled_capital',
    // besides above static props
    // tape will also have dynamic properties
    // specified by the node configuration
    //
    // externalReceivableIdField,
    // limitedPartnerNameAliasField,
];
// optional properties regarding LP from a receivable (commitment) tape.
exports.LimitedPartnerTapeOptionalStaticProps = [
    { fieldName: 'recallable_capital', fieldType: 'float' },
];
exports.LimitedPartnerCommitmentSchema = v4_1.z.object({
    limitedPartnerAlias: v4_1.z.string(),
    finleyReceivableId: v4_1.z.string(),
    limitedPartnerId: v4_1.z.string().nullable(),
    limitedPartnerName: v4_1.z.string().nullable(),
    creditFacilityId: v4_1.z.string(),
    creditFacilityName: v4_1.z.string(),
    borrowerSlug: v4_1.z.string(),
    borrowerName: v4_1.z.string(),
    committedCapital: v4_1.z.number(),
    uncalledCapital: v4_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
});
exports.LimitedPartnerCommitmentDetailSchema = v4_1.z.object({
    limitedPartnerAlias: v4_1.z.string(),
    finleyReceivableId: v4_1.z.string(),
    limitedPartnerId: v4_1.z.string(),
    limitedPartnerName: v4_1.z.string(),
    creditFacilityId: v4_1.z.string(),
    creditFacilityName: v4_1.z.string(),
    borrowerSlug: v4_1.z.string(),
    borrowerName: v4_1.z.string(),
    committedCapital: v4_1.z.number(),
    uncalledCapital: v4_1.z.number(),
    recallableCapital: v4_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
    eligibleUncalledCapitalLessKickouts: v4_1.z.number(),
    netUncalledCapital: v4_1.z.number(),
    percentageOfNetUncalledCapital: v4_1.z.number(),
    mappingId: v4_1.z.string(),
    matchedByUserName: v4_1.z.string().nullable(),
    matchedByUserEmail: v4_1.z.string().nullable(),
    matchedAt: v4_1.z.string().transform((val) => new Date(val)),
});
exports.LimitedPartnerCapitalTrendDataSchema = v4_1.z.object({
    finleyReceivableId: v4_1.z.string(),
    committedCapital: v4_1.z.number(),
    uncalledCapital: v4_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
});
exports.PortfolioOverviewGraphDataSchema = v4_1.z.object({
    totalPrincipalBalance: v4_1.z.number(),
    totalUncalledCapital: v4_1.z.number(),
    totalCommittedCapital: v4_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
});
exports.LimitedPartnerPortfolioSummarySchema = v4_1.z.object({
    totalUncalledCapital: v4_1.z.number(),
    totalCommittedCapital: v4_1.z.number(),
    commitmentCount: v4_1.z.number().int(),
    limitedPartnerCount: v4_1.z.number().int(),
});
exports.AggregatedLimitedPartnerCommitmentDataSchema = v4_1.z.object({
    limitedPartnerName: v4_1.z.string(),
    limitedPartnerId: v4_1.z.string(),
    commitmentCount: v4_1.z.number().int(),
    totalCommittedCapital: v4_1.z.number(),
    totalRecallableCapital: v4_1.z.number(),
    percentageOfPortfolioCommittedCapital: v4_1.z.number(),
    totalUncalledCapital: v4_1.z.number(),
    percentageOfPortfolioUncalledCapital: v4_1.z.number(),
    eligibleUncalledCapital: v4_1.z.number(),
    eligibleUncalledCapitalLessKickouts: v4_1.z.number(),
    advanceRate: v4_1.z.number(),
    netUncalledCapital: v4_1.z.number(),
    percentageOfPortfolioNetUncalledCapital: v4_1.z.number(),
});
//# sourceMappingURL=LimitedPartners.js.map